import React from 'react';
import './loading.scss';

const Loading = () => (

  <div className="loading-spinner">
    <div className="spinner" />
  </div>

);

export default Loading;